// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"339":"d58c9e7d","434":"92ee34bb","640":"263cc784","655":"dc38a4df","739":"01ac67d6","815":"a7474ae7","907":"77e1a148","945":"d2bf8bd0","979":"3a3610e9"}[chunkId] + ".chunk.css";
};